const carousel = {
  carouselIdendity:
    'Centralise your entire digital identity in a single profile',
  carouselClickTree: 'More than clicks, trees planted',
  carouselReward: 'Turn your rewards into exclusive offers',
}

export default carousel
